import { render, staticRenderFns } from "./requiredFields.vue?vue&type=template&id=48d1f14a&scoped=true&"
import script from "./requiredFields.vue?vue&type=script&lang=js&"
export * from "./requiredFields.vue?vue&type=script&lang=js&"
import style0 from "./requiredFields.vue?vue&type=style&index=0&id=48d1f14a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d1f14a",
  null
  
)

export default component.exports